import { useEffect, useRef, useState } from 'react';

const getFileFromValue = value => {
    if (!value) {
        return null;
    }

    const first = Array.isArray(value) ? value[0] : value;
    if (!first) {
        return null;
    }

    if (first.rawFile instanceof File) {
        return first.rawFile;
    }

    if (first instanceof File) {
        return first;
    }

    return null;
};

const getSrcFromValue = value => {
    if (!value) {
        return null;
    }

    const first = Array.isArray(value) ? value[0] : value;
    if (!first) {
        return null;
    }

    if (typeof first === 'string') {
        return first;
    }

    if (typeof first.src === 'string') {
        return first.src;
    }

    return null;
};

export const useImagePreview = value => {
    const objectUrlRef = useRef(null);
    const [previewUrl, setPreviewUrl] = useState(null);

    useEffect(() => {
        if (objectUrlRef.current) {
            URL.revokeObjectURL(objectUrlRef.current);
            objectUrlRef.current = null;
        }

        const file = getFileFromValue(value);
        if (file) {
            try {
                const objectUrl = URL.createObjectURL(file);
                objectUrlRef.current = objectUrl;
                setPreviewUrl(objectUrl);
            } catch {
                objectUrlRef.current = null;
                setPreviewUrl(null);
            }
            return () => {
                if (objectUrlRef.current) {
                    URL.revokeObjectURL(objectUrlRef.current);
                    objectUrlRef.current = null;
                }
            };
        }

        setPreviewUrl(getSrcFromValue(value));
        return undefined;
    }, [value]);

    return previewUrl;
};
